import { apiErrorEpic, resetApiErrorEpic } from './ducks/apiError/apiError';
import {
  activateProductEpic,
  activateProductSuccessEpic,
  cancelProductEpic,
  getProductCatalogueEpic,
  getProductsEpic,
} from './ducks/products/products';
import { getRecommendedDirectDebitEpic } from './ducks/recommendedDirectDebit/recommendedDirectDebit';
import {
  getShowSmartMeterBookingBannerEpic,
  getSmartMeterBookingEpic,
} from './ducks/smartMeterBooking/smartMeterBooking';
import { fetchTariffCostsEpic } from './ducks/tariffCosts/tariffCosts';
import { getDateRangeMonthlyUsageEpic } from './ducks/usage/monthly-usage';

const epics = [
  getDateRangeMonthlyUsageEpic,
  apiErrorEpic,
  resetApiErrorEpic,
  getProductsEpic,
  getProductCatalogueEpic,
  activateProductEpic,
  activateProductSuccessEpic,
  cancelProductEpic,
  getRecommendedDirectDebitEpic,
  getShowSmartMeterBookingBannerEpic,
  getSmartMeterBookingEpic,
  fetchTariffCostsEpic,
];

export default epics;
